import React, {Component, Fragment} from 'react';
import {
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table
} from 'reactstrap';
import LaddaButton, {EXPAND_RIGHT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './cameralist.css';
import {getData} from '../../api/doLogin.js';
import io from "../../api/socket.io";
import {postData} from "../../api/doLogin";
import {zPad} from "../Applications/shared/shared";
import {checkPerms} from '../../api/permissions.js';
import {Terminal} from 'xterm';
import './xterm.css';
import {hasPermission, RequiredPermission} from "../../api/permissionHelper";
import {PermissionsUserPicker} from "../../components/Permissions/PermissionsUserPicker";
import {CameraPermissionsUserPicker} from "./CameraPermissionsUserPicker";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class CameraList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cameraList: [],
      data: [],
      dataLoaded: false,
      connected: false,
      terminal: "",
      terminalDisplay: "",
      audio: "",
      audioDevices: [],
      audioChosen: "",
      WAPs: [],
      savedWAPs: [],
      wifi: "",
      currentWifi: null,
      wifiSsid: "",
      wifiPsk: "",
      wifiError: "",
      waitIndicator: false,
      showAll: false,
      showAssignDialog: null,
      assignDisplay: "",
    };

    this.table = this.state.data || [];
    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 10,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.canAddAll = false;
    this.canPermissionAssign = false;
    this.canDebug = false;
    this.socket = null;
    // this.url = "https://picam-server.apps.smithos.net/";
    this.url = "https://picam.aws01.webtest.us/";
  }

  componentDidMount() {
    this.canAddAll = hasPermission(RequiredPermission.CameraListAll);
    this.canDebug = hasPermission(RequiredPermission.CameraDebug);
    this.canPermissionAssign = hasPermission(RequiredPermission.CameraAssignPermissions);
    this.updateData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type) {
      this.updateData();
    }
  }

  componentWillUnmount() {
    if (this.socket) {
      this.disconnect();
      this.socket.destroy();
    }
  }

  manualReconnect() {
    let self = this;
    this.disconnect();
    setTimeout(() => {
      self.reconnect();
    }, 500);
  }

  reconnect() {
    // this.connectSocketServer(this.state.cameraList);
    this.updateData();
  }

  disconnect() {
    if (this.state.terminal !== "") this.closeTerm(this.state.terminal);
    this.socket.off('connect', function (data) {
    });
    this.socket.off('disconnect', function (data) {
    });
    this.socket.off('request', function (data) {
    });
    this.socket.off('response', function (data) {
    });
    this.socket.off('terminal-out', function (data) {
    });
    this.socket.disconnect();
  }

  updateData() {
    var self = this;
    getData(`camera/list${this.state.showAll ? "all" : ""}`, {})
      .then((data) => {
        if (data.status === "Success") {
          self.setState({cameraList: data.data.cameras, dataLoaded: true});
          if (data.data.cameras.length > 0) {
            this.connectSocketServer(data.data.cameras.map(device => device.id));
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  setDropdown(i, val) {
    const newList = this.state.cameraList;
    if (newList[i]) {
      newList[i]['dropdown'] = val;
    }
    this.setState({cameraList: newList});
  }

  getDropdown(i) {
    if (this.state.cameraList[i]) {
      if (this.state.cameraList[i]['dropdown']) {
        return this.state.cameraList[i]['dropdown'];
      }
    }
    return false;
  }

  render() {
    let self = this;
    return (
      <div className="animated fadeIn">
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              <i className="icon-menu"/>Cameras <i className="icon-globe"
                                                   style={{color: this.state.connected ? brandInfo : brandDanger}}
                                                   title={this.state.connected ? "Connected" : "Not Connected"}/>

              <div className="card-actions">

                <button onClick={() => this.manualReconnect()} style={{width: 100}}>
                  <small className="text-muted">Refresh List</small>
                </button>

                {hasPermission(RequiredPermission.CameraListAll) && (
                  <button onClick={() => this.setState({showAll: !this.state.showAll}, () => this.manualReconnect())}
                          style={{width: 100}}>
                    <small className="text-muted">{this.state.showAll ? "My" : "All"} Cameras</small>
                  </button>
                )}

                <button onClick={() => this.props.history.push(`/cameras/viewmedia`)} style={{width: 100}}>
                  <small className="text-muted">View Recordings</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              {this.state.cameraList.length > 0 ?
                <Fragment>
                  {/*<div style={{textAlign: 'right'}}>&nbsp;</div>*/}
                  <Table hover bordered striped responsive size="sm">
                    <thead>
                    <tr>
                      <th width="20%">Display</th>
                      <th width="20%">Status/Version</th>
                      <th width="20%">Last Response</th>
                      <th width="20%">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.cameraList && this.state.cameraList.map((data, index) => {

                      const buttonColor = function (status) {
                        switch (status) {
                          case "ready":
                            return "info";
                            break;
                          case "recording":
                            return "danger";
                          default:
                            return "";
                        }
                      };
                      const buttonDisable = function (status) {
                        if (!self.state.connected) return true;
                        switch (status) {
                          case "ready":
                          case "recording":
                            return false;
                            break;
                          default:
                            return true;
                        }
                      };
                      const buttonText = function (status) {
                        switch (status) {
                          case "ready":
                            return "Record";
                            break;
                          case "recording":
                            return "Stop";
                          default:
                            return "";
                        }
                      };
                      const statusText = function (status) {
                        switch (status) {
                          case "ready":
                            return "Idle";
                            break;
                          case "recording":
                            return "Recording...";
                          case "disconnected":
                            return "Offline";
                          default:
                            return "Retrieving...";
                        }
                      };
                      const displayDate = function (dated) {
                        if (!dated) return "";
                        if (typeof (dated) != "number") return dated;
                        const dateObject = new Date(dated);
                        const date = [dateObject.getFullYear(), zPad((dateObject.getMonth() + 1).toString(), 2), zPad(dateObject.getDate().toString(), 2)].join("-");
                        const time = [zPad(dateObject.getHours().toString(), 2), zPad((dateObject.getMinutes() + 1).toString(), 2), zPad(dateObject.getSeconds().toString(), 2)].join(":");
                        return date + " " + time;
                      };

                      let cameraDisplay = data.display === data.id ? data.display : data.display + ` (${data.id.substr(32)})`;

                      return (<tr key={index}>
                        <td>{cameraDisplay}</td>
                        <td>{statusText(data.status)}<span
                          style={{fontSize: 8, float: "right"}}>{data.version || ""}</span></td>
                        <td>{data.last_response ? displayDate(data.last_response) : data.last_time.split(".")[0].replace('T', ' ')}</td>
                        <td>
                          <Fragment>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                              <ButtonDropdown
                                className="mr-1"
                                isOpen={this.getDropdown(index)}
                                toggle={() => {
                                  this.setDropdown(index, !this.getDropdown(index));
                                }}>
                                {buttonDisable(data.status) || data.access === 0 ?
                                  <Button
                                    onClick={() => this.props.history.push(`/cameras/viewmedia/${data.id}`)}
                                  >View Media</Button>
                                  :
                                  <Button
                                    id="caret"
                                    disabled={buttonDisable(data.status)}
                                    color={buttonColor(data.status)}
                                    onClick={() => {
                                      this.setDropdown(index, false);
                                      if (data.status === "ready") {
                                        this.sendCommand(data.id, 'record');
                                      } else if (data.status === "recording") {
                                        this.sendCommand(data.id, 'stop');
                                      }
                                    }}
                                  >{buttonText(data.status)}</Button>
                                }

                                <DropdownToggle
                                  caret
                                  color={buttonColor(data.status)}
                                  disabled={buttonDisable(data.status) || data.access === 0}/>
                                <DropdownMenu>
                                  {/*<DropdownItem header>Header</DropdownItem>*/}
                                  {/*<DropdownItem disabled>Action Disabled</DropdownItem>*/}
                                  <DropdownItem
                                    disabled={data.status !== "ready"}
                                    onClick={() => this.sendCommand(data.id, 'preview')}
                                  >Grab Preview</DropdownItem>
                                  <DropdownItem
                                    disabled={data.status !== "ready"}
                                    onClick={() => this.sendCommand(data.id, 'still')}
                                  >Capture Still Image</DropdownItem>

                                  <DropdownItem
                                    onClick={() => this.props.history.push(`/cameras/viewmedia/${data.id}`)}
                                  >View Media</DropdownItem>

                                  <DropdownItem
                                    onClick={() => this.updateDisplay(data.id, data.display)}
                                  >Edit Display Name</DropdownItem>
                                  {/*<DropdownItem*/}
                                  {/*  onClick={() => this.sendCommand(data.id, 'stop')}>Stop</DropdownItem>*/}
                                  <DropdownItem
                                    onClick={() => this.sendCommand(data.id, 'update')}
                                    disabled={data.status !== "ready"}
                                  >Update Device</DropdownItem>

                                  {self.canDebug && (
                                    <DropdownItem
                                      onClick={() => this.sendCommand(data.id, 'updateDev')}
                                      disabled={data.status !== "ready"}
                                    >Update (BETA)</DropdownItem>
                                  )}

                                  <DropdownItem
                                    onClick={() => {
                                      this.setState({terminalDisplay: data.display})
                                      this.sendCommand(data.id, 'audiodevices');
                                    }}
                                    disabled={data.status !== "ready"}
                                  >Audio Settings</DropdownItem>

                                  <DropdownItem
                                    onClick={() => {
                                      this.setState({
                                        terminalDisplay: data.display,
                                        wifi: data.id,
                                        wifiSsid: "",
                                        wifiPsk: "",
                                        currentWifi: null,
                                        wifiError: "",
                                        waitIndicator: false
                                      })
                                      this.sendCommand(data.id, 'scanwifi');
                                    }}
                                    disabled={data.status !== "ready"}
                                  >Wifi Settings</DropdownItem>

                                  {self.canDebug && (
                                    <DropdownItem
                                      onClick={() => {
                                        this.setState({terminalDisplay: data.display})
                                        this.sendCommand(data.id, 'terminal-open')
                                      }}
                                    >Open Terminal</DropdownItem>
                                  )}

                                  <DropdownItem
                                    disabled={data.status !== "ready"}
                                    onClick={() => {
                                      if (confirm("Are you sure you want to restart?")) {
                                        this.sendCommand(data.id, 'restart');
                                      }
                                    }}
                                  >Restart</DropdownItem>

                                  {self.canDebug && (
                                    <DropdownItem
                                      onClick={() => {
                                        if (confirm("Are you sure you want to shutdown?")) {
                                          this.sendCommand(data.id, 'shutdown');
                                        }
                                      }}
                                    >Shutdown</DropdownItem>
                                  )}
                                </DropdownMenu>
                              </ButtonDropdown>
                              {this.canPermissionAssign && (
                                <Button onClick={() => this.setState({
                                  showAssignDialog: data.id,
                                  assignDisplay: cameraDisplay
                                })}>Users</Button>
                              )}
                            </div>
                            {data['preview'] && (
                              <div>
                                <button onClick={() => {
                                  const currentState = this.state.cameraList;
                                  currentState.map((currentDevice, curIndex) => {
                                    if (data.id === currentDevice.id) {
                                      delete currentState[curIndex]['preview'];
                                    }
                                  });
                                  this.setState({cameraList: [...currentState]});
                                }}>Close
                                </button>
                                <img src={data['preview']}/>
                              </div>
                            )}
                          </Fragment>
                        </td>
                      </tr>)
                    })}
                    </tbody>
                  </Table>
                </Fragment>
                :
                <div style={{textAlign: "center"}}>No cameras. Select Add from above to link to you account.</div>
              }
            </CardBody>
            <Modal isOpen={this.state.terminal.length > 0}
                   className={'modal-lg ' + this.props.className}>
              <ModalHeader>Terminal - {this.state.terminalDisplay}</ModalHeader>
              <ModalBody>
                <div id={"terminal"} style={{width: 750, display: 'inline-block', height: 500}}/>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary"
                        onClick={() => self.sendCommand(self.state.terminal, 'terminal-close')}>Close</Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={this.state.audio.length > 0}
                   className={'modal-lg ' + this.props.className}>
              <ModalHeader>Audio Settings - {this.state.terminalDisplay}</ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label for="list">Selected Microphone</Label>
                  <Input type="select" value={this.state.audioChosen} onChange={(evt) => {
                    this.setState({audioChosen: evt.target.value});
                  }}>
                    <option key={0} value="" disabled={true}>Choose from list...</option>
                    {this.state.audioDevices.map((device, index) => {
                      return (
                        <option key={index + 1}
                                value={`CARD=${device.cardName},DEV=${device.device}`}>{device.cardDisplay}</option>
                      )
                    })}
                  </Input>
                </FormGroup>
              </ModalBody>
              <ModalFooter>
                <Button color="primary"
                        onClick={() => self.sendCommandUpdate(self.state.audio, 'setaudio', self.state.audioChosen)}>Save</Button>
                <Button color="secondary"
                        onClick={() => self.setState({audio: ""})}>Close</Button>
              </ModalFooter>
            </Modal>

            <Modal isOpen={this.state.wifi.length > 0}
                   className={'modal-lg ' + this.props.className}>
              <ModalHeader>Wifi Settings - {this.state.terminalDisplay}</ModalHeader>
              <ModalBody>
                <div>Current
                  Wifi: {(this.state.currentWifi && this.state.currentWifi['ssid']) ? `${this.state.currentWifi['ssid']} (IP:${this.state.currentWifi['ip_address']})` : "N/A"}</div>
                <div style={{width: "100%", maxHeight: 450, overflowY: "auto"}}>
                  <Table>
                    <thead>
                    <tr>
                      <td>SSID</td>
                      <td>Signal</td>
                      <td>Action</td>
                    </tr>
                    </thead>
                    <tbody>
                    {self.removeSet(this.state.WAPs.sort((a, b) => a.signalLevel <= b.signalLevel ? 1 : -1)).map((wifi, index) => {
                      return (
                        <tr key={index}>
                          <td>{wifi.ssid}</td>
                          <td>{wifi.signalLevel}</td>
                          <td>
                            <Button
                              color="success"
                              onClick={() => self.setState({wifiSsid: wifi.ssid})}
                            >Connect</Button>

                            {self.state.savedWAPs && self.state.savedWAPs.includes(wifi.ssid) && (
                              <Button
                                color="danger"
                                onClick={() => self.sendCommandUpdate(self.state.wifi, 'removewifi', {
                                  ssid: wifi.ssid
                                })}
                              >X</Button>
                            )}

                          </td>
                        </tr>
                      )
                    })}
                    </tbody>


                  </Table>
                </div>

                {(this.state.wifiSsid && this.state.wifiSsid.length > 0) && (
                  <FormGroup>
                    <Label for="psk">Passphrase</Label>
                    <Input
                      type="password"
                      value={this.state.wifiPsk}
                      onChange={(evt) => this.setState({wifiPsk: evt.target.value})}
                    />
                  </FormGroup>
                )}

                {this.state.wifiError && this.state.wifiError.length > 0 && (
                  <div color="danger">Error: Failed to connect to {this.state.wifiSsid}</div>
                )}

              </ModalBody>
              <ModalFooter>
                <Button color="secondary"
                        onClick={() => self.sendCommand(self.state.wifi, 'scanwifi')}>Refresh</Button>
                <LaddaButton
                  className="btn btn-info btn-ladda"
                  disabled={self.state.wifiSsid.length === 0}
                  loading={this.state.waitIndicator}
                  onClick={() => {
                    self.setState({waitIndicator: true});
                    self.sendCommandUpdate(self.state.wifi, 'setwifi', {
                      ssid: self.state.wifiSsid,
                      psk: self.state.wifiPsk
                    });
                  }}
                  data-color="blue"
                  data-style={EXPAND_RIGHT}
                >Save</LaddaButton>
                <Button color="secondary"
                        onClick={() => self.setState({wifi: ""})}>Close</Button>
              </ModalFooter>
            </Modal>
            {this.state.showAssignDialog && (
              <CameraPermissionsUserPicker title={`Camera - ${this.state.assignDisplay}`}
                                           type={"camera"}
                                           selected={this.state.showAssignDialog}
                                           onClose={() => {
                                             this.setState({
                                               showAssignDialog: null,
                                               assignDisplay: ""
                                             });
                                           }}
              />
            )}
          </Card>
        )}
      </div>
    )
  }

  removeSet(array) {
    let unique = [];
    let output = [];
    array.map((item) => {
      if (unique.indexOf(item.ssid) === -1) {
        unique.push(item.ssid);
        output.push(item);
      }
    });
    return output;
  }

  keepSsid(array) {
    let unique = [];
    array.map((item) => {
      if (unique.indexOf(item.ssid) === -1) {
        unique.push(item.ssid);
      }
    });
    return unique;
  }

  connectSocketServer(devices) {
    let self = this;
    this.socket = io(self.url);
    console.log("Connecting to " + self.url);
    // this.socket = io("http://localhost:8080");
    this.socket.on('connect', function () {
      console.log('I am connected to camera sockets');
      self.setState({connected: true});
      self.socket.emit('request', {action: "login", type: "client", step: 0, loginId: 1, deviceIds: devices});
    });
    this.socket.on('disconnect', function () {
      console.log("Disconnected");
      self.setState({connected: false});
    });
    this.socket.on('request', function (data) {
      switch (data.action) {
        case "sethost":
          if (data['data'] && data['data']['host']) {
            self.url = data['data']['host'];
            self.disconnect();
            setTimeout(() => {
              self.reconnect();
            }, 1000);
          }
          break;
      }
    });
    this.socket.on('response', function (data) {
      // console.log(data);
      const currentState = self.state.cameraList;
      switch (data.action) {
        case "login":
          if (data.result === "Success") {
            self.socket.emit('request', {action: "devices"});
          }
          break;
        case "devices":
          data.data.map((device, index) => {
            currentState.map((currentDevice, curIndex) => {
              if (device.deviceId === currentDevice.id) {
                currentState[curIndex].status = device.status;
                currentState[curIndex].version = device.version;
                currentState[curIndex].last_response = device.lastTime;
              }
            });
          });
          self.setState({cameraList: [...currentState]});
          break;
        case "device":
          currentState.map((currentDevice, curIndex) => {
            if (data.data.deviceId === currentDevice.id) {
              currentState[curIndex].status = data.data.status;
              currentState[curIndex].version = data.data.version;
              currentState[curIndex].last_response = data.data.lastTime;
            }
          });
          self.setState({cameraList: [...currentState]});
          break;
        case "preview":
          if (data.state !== "captured") return;
          currentState.map((currentDevice, curIndex) => {
            if (data.replyTo === currentDevice.id) {
              currentState[curIndex]['preview'] = data.data;
              // currentState[curIndex].last_response = data.data.lastTime;
            }
          });
          self.setState({cameraList: [...currentState]});
          break;
        case "terminal-open":
          if (data.result === "Success") {
            self.setState({terminal: data.deviceId}, () => {
              setTimeout(() => {

                if (!self.term) {
                  self.term = new Terminal();
                  self.term.open(document.getElementById('terminal'));

                  self.term.on('data', function (data) {
                    self.socket.emit('terminal-in', {deviceId: self.state.terminal, data: data});
                  });

                  self.socket.emit('terminal-in', {
                    deviceId: self.state.terminal,
                    data: "\x17export TERM=xterm && clear\n"
                  });

                  self.term.focus();
                  self.term.clear();
                  self.term.write('Connecting...');
                }
              }, 250);
            });
          }
          break;
        case "terminal-close":
          if (data.result === "Success") {
            self.closeTerm(data.deviceId);
          }
          break;
        case "audiodevices":
          if (data.state === "list") {
            self.setState({audio: data.replyTo, audioDevices: data.data.list, audioChosen: data.data.selected});
          }
          break;
        case "setaudio":
          if (data.state === "saved") {
            self.setState({audio: ""});
          } else {
            alert("Error Saving:" + data.msg);
          }
          break;
        case "scanwifi":
          if (data.state === "list") {
            self.setState({
              currentWifi: data.data.status,
              WAPs: data.data.list,
              savedWAPs: self.keepSsid(data.data.saved)
            });
          }
          break;
        case "setwifi":
          if (data.state === "saved") {
            self.setState({wifi: ""});
          } else {
            self.setState({wifiError: data.msg});
          }
          break;
        case "removewifi":
          if (data.state === "removed") {
            self.sendCommand(self.state.wifi, 'scanwifi');
          }
          break;
      }
    });
    this.socket.on('terminal-out', function (data) {
      // console.log(data);
      if (data.hasOwnProperty("deviceId")) {
        self.term.write(data.data);
        // console.log('out', data.data);
      }
    });
  }

  closeTerm(openTerm) {
    if (openTerm === this.state.terminal) {
      this.term.off('data', function (data) {
      });
      this.term.destroy();
      this.term.dispose();
      this.term = null;
      this.setState({terminal: ""});
    }
  }

  sendCommand(deviceId, action) {
    this.socket.emit('request', {action: action, deviceId: deviceId});
    // console.log("requested " + action);
  }

  sendCommandUpdate(deviceId, action, data) {
    this.socket.emit('request', {action: action, deviceId: deviceId, data: data});
    // console.log("requested " + action + " using " + data);
  }

  updateDisplay(deviceId, display) {
    const newDisplay = prompt("New Display", display);
    if (newDisplay && newDisplay !== "" && newDisplay !== display) {
      var self = this;
      postData("camera/updateDisplay", {deviceId: deviceId, display: newDisplay}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            const currentState = self.state.cameraList;
            currentState.map((currentDevice, curIndex) => {
              if (deviceId === currentDevice.id) {
                currentState[curIndex]['display'] = newDisplay;
                // currentState[curIndex].last_response = data.data.lastTime;
              }
            });
            self.setState({cameraList: [...currentState]});
          }
        })
        .catch(error => {
          console.error(error);
        });

    }
  }
}

export default CameraList;



// WEBPACK FOOTER //
// ./src/containers/Camera/CameraList.js